//对账

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 状态
 */
class ReconciliationState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    // 用户pc：待确认initiator=1，state=3；确认中：initiator=2，state=3
    // 待确认状态在pc端是发起方是内部用户 状态为确认中的数据  ，在管理后台是发起方是客户 状态为确认中的数据
    WAIT_CONFIRM = new Meta(2, "待确认");
    CONFIRMING = new Meta(3, "确认中");
    // 待签署状态是状态为4，签署状态是自己这方未签署2或者双方未签署0的状态 同合同
    TO_BE_INITIATE = new Meta(7, "待发起");
    TO_BE_SIGNED = new Meta(8, "待签署");
    SIGNING = new Meta(4, "签署中");
    FINISHED = new Meta(5, "结算完成");
    REJECTED = new Meta(6, "已驳回");
    INVALIDING = new Meta(9, "作废中");
    INVALID = new Meta(10, "已作废");
    PRE_FINISHED = new Meta(11, "预结算完成");
}

export const RECONCILIATION_STATE = new ReconciliationState();

// 状态-线上签署-管理端-新增对账
class AdminAdminReconciliationState extends UltMeta {
    DRAFT: Meta;
    TO_BE_INITIATE: Meta;
    TO_BE_SIGNED: Meta;
    SIGNING: Meta;
    FINISHED: Meta;
    constructor(_PRESTATUS: boolean, _STATUS: boolean) {
        super();
        if (_PRESTATUS && _STATUS) {
            this.DRAFT = new Meta(11, "预结算完成");
        } else {
            this.DRAFT = new Meta(1, "草稿");
        }
        this.TO_BE_INITIATE = new Meta(7, "待发起");
        this.TO_BE_SIGNED = new Meta(8, "待签署");
        this.SIGNING = new Meta(4, "签署中");
        this.FINISHED = _PRESTATUS && !_STATUS ? new Meta(11, "预结算完成") : new Meta(5, "结算完成");
    }
}
// _STATUS为false-正常对账流程,_STATUS为true-预对账流程
export const ADMIN_ADMIN_RECONCILIATION_STATE = (_PRESTATUS: boolean, _STATUS: boolean) => {
    return new AdminAdminReconciliationState(_PRESTATUS, _STATUS);
};
// 状态-线上签署-用户端-新增对账
class AdminCustomReconciliationState extends UltMeta {
    PRE_FINISHED: Meta | undefined;
    TO_BE_SIGNED: Meta;
    SIGNING: Meta;
    FINISHED: Meta;
    constructor(_PRESTATUS: boolean, _STATUS: boolean) {
        super();
        if (_PRESTATUS && _STATUS) {
            this.PRE_FINISHED = new Meta(11, "预结算完成");
        }
        this.TO_BE_SIGNED = new Meta(8, "待签署");
        this.SIGNING = new Meta(4, "签署中");
        this.FINISHED = _PRESTATUS && !_STATUS ? new Meta(11, "预结算完成") : new Meta(5, "结算完成");
    }
}
export const ADMIN_CUSTOM_RECONCILIATION_STATE = (_PRESTATUS: boolean, _STATUS: boolean) => {
    return new AdminCustomReconciliationState(_PRESTATUS, _STATUS);
};
//状态-线下签署-管理端-新增对账
class AdminOfflineAdminReconciliationState extends UltMeta {
    DRAFT: Meta;
    CONFIRMING: Meta;
    FINISHED: Meta;
    constructor(_PRESTATUS: boolean, _STATUS: boolean) {
        super();
        if (_PRESTATUS && _STATUS) {
            this.DRAFT = new Meta(11, "预结算完成");
        } else {
            this.DRAFT = new Meta(1, "草稿");
        }
        this.CONFIRMING = new Meta(3, "确认中");
        this.FINISHED = _PRESTATUS && !_STATUS ? new Meta(11, "预结算完成") : new Meta(5, "结算完成");
    }
}
export const ADMIN_OFFLINE_ADMIN_RECONCILIATION_STATE = (_PRESTATUS: boolean, _STATUS: boolean) => {
    return new AdminOfflineAdminReconciliationState(_PRESTATUS, _STATUS);
};
// 状态-线下签署-用户端-新增对账
class AdminOfflineCustomReconciliationState extends UltMeta {
    PRE_FINISHED: Meta | undefined;
    WAIT_CONFIRM: Meta;
    FINISHED: Meta;
    constructor(_PRESTATUS: boolean, _STATUS: boolean) {
        super();
        if (_PRESTATUS && _STATUS) {
            this.PRE_FINISHED = new Meta(11, "预结算完成");
        }
        this.WAIT_CONFIRM = new Meta(3, "待确认");
        this.FINISHED = _PRESTATUS && !_STATUS ? new Meta(11, "预结算完成") : new Meta(5, "结算完成");
    }
}
export const ADMIN_OFFLINE_CUSTOM_RECONCILIATION_STATE = (_PRESTATUS: boolean, _STATUS: boolean) => {
    return new AdminOfflineCustomReconciliationState(_PRESTATUS, _STATUS);
};

//状态-线下签署-用户端
class CustomOfflineAdminReconciliationState extends UltMeta {
    PRE_FINISHED: Meta | undefined;
    WAIT_CONFIRM: Meta;
    FINISHED: Meta;
    constructor(_PRESTATUS: boolean, _STATUS: boolean) {
        super();
        if (_PRESTATUS && _STATUS) {
            this.PRE_FINISHED = new Meta(11, "预结算完成");
        }
        this.WAIT_CONFIRM = new Meta(3, "待确认");
        this.FINISHED = new Meta(5, "结算完成");
        if (_PRESTATUS && !_STATUS) {
            this.FINISHED = new Meta(11, "预结算完成");
        }
    }
}
export const CUSTOM_OFFLINE_ADMIN_RECONCILIATION_STATE = (_PRESTATUS: boolean, _STATUS: boolean) => {
    return new CustomOfflineAdminReconciliationState(_PRESTATUS, _STATUS);
};

//状态-线上签署-用户端发起-已完成对账
class CustomAdminReconciliationState extends UltMeta {
    PRE_FINISHED: Meta | undefined;
    TO_BE_SIGNED: Meta;
    SIGNING: Meta;
    FINISHED: Meta;
    constructor(_PRESTATUS: boolean, _STATUS: boolean) {
        super();
        if (_PRESTATUS && _STATUS) {
            this.PRE_FINISHED = new Meta(11, "预结算完成");
        }
        this.TO_BE_SIGNED = new Meta(8, "待签署");
        this.SIGNING = new Meta(4, "签署中");
        this.FINISHED = new Meta(5, "结算完成");
        if (_PRESTATUS && !_STATUS) {
            this.FINISHED = new Meta(11, "预结算完成");
        }
    }
}
export const CUSTOM_ADMIN_RECONCILIATION_STATE = (_PRESTATUS: boolean, _STATUS: boolean) => {
    return new CustomAdminReconciliationState(_PRESTATUS, _STATUS);
};
// 状态-线上签署-用户端-已完成对账
class CustomCustomReconciliationState extends UltMeta {
    DRAFT: Meta;
    TO_BE_SIGNED: Meta;
    SIGNING: Meta;
    FINISHED: Meta;
    constructor(_PRESTATUS: boolean, _STATUS: boolean) {
        super();
        this.DRAFT = new Meta(1, "草稿");
        if (_PRESTATUS && _STATUS) {
            this.DRAFT = new Meta(11, "预结算完成");
        }
        this.TO_BE_SIGNED = new Meta(8, "待签署");
        this.SIGNING = new Meta(4, "签署中");
        this.FINISHED = new Meta(5, "结算完成");
        if (_PRESTATUS && !_STATUS) {
            this.FINISHED = new Meta(11, "预结算完成");
        }
    }
}
export const CUSTOM_CUSTOM_RECONCILIATION_STATE = (_PRESTATUS: boolean, _STATUS: boolean) => {
    return new CustomCustomReconciliationState(_PRESTATUS, _STATUS);
};
// 状态-线下签署-用户端发起
class CustomOfflineCustomReconciliationState extends UltMeta {
    DRAFT: Meta;
    CONFIRMING: Meta;
    FINISHED: Meta;
    constructor(_PRESTATUS: boolean, _STATUS: boolean) {
        super();
        this.DRAFT = new Meta(1, "草稿");
        if (_PRESTATUS && _STATUS) {
            this.DRAFT = new Meta(11, "预结算完成");
        }
        this.CONFIRMING = new Meta(3, "确认中");
        this.FINISHED = new Meta(5, "结算完成");
        if (_PRESTATUS && !_STATUS) {
            this.FINISHED = new Meta(11, "预结算完成");
        }
    }
}
export const CUSTOM_OFFLINE_CUSTOM_RECONCILIATION_STATE = (_PRESTATUS: boolean, _STATUS: boolean) => {
    return new CustomOfflineCustomReconciliationState(_PRESTATUS, _STATUS);
};

class ReconciliationDetailState extends UltMeta {
    NOT_RECONCILIATION = new Meta(0, "未结算");
    RECONCILING = new Meta(1, "结算中");
    RECONCILED = new Meta(2, "结算完成");
    INVALID = new Meta(3, "作废中");
    PRE_RECONCILIATION = new Meta(4, "预结算");
}
export const RECONCILIATION_DETAIL_STATE = new ReconciliationDetailState();

// 控货比要求

class ReconciliationControlRatioWay extends UltMeta {
    RATIO = new Meta(1, "按比例");
    AMOUNT = new Meta(2, "按金额");
}

export const RECONCILIATION_CONTROL_TYPE = new ReconciliationControlRatioWay();
// 账期
class SettlePeriodControlRatioWay extends UltMeta {
    MONTH = new Meta(1, "按月");
    DAY = new Meta(2, "按天");
}

export const SETTLE_CONTROL_TYPE = new SettlePeriodControlRatioWay();

/**
 * 开票状态
 */
class InvoiceState extends UltMeta {
    NOT_INVOICED = new Meta(0, "未开票");
    INVOICING = new Meta(1, "开票中");
    FINISHED = new Meta(2, "已开票");
}

export const INVOICE_STATE = new InvoiceState();

class ReconciliationBusinessState extends UltMeta {
    NOT_STARTED = new Meta(0, "未开始");

    IN_PROGRESS = new Meta(1, "进行中");

    COMPLETED = new Meta(2, "已完成");

    INVALID = new Meta(3, "作废中");

    PRE_RECONCILIATION = new Meta(4, "预对账");
}

export const RECONCILIATION_BUSINESS_STATE = new ReconciliationBusinessState();
